import { Dispatch, SetStateAction, useEffect } from 'react';

import { FormDataType } from '../constants/WebAppSettingsFormConstants';
import { useGetWebApplicationSettingsQuery } from '../services';

export const useWebAppSettingsForm = (setFormData: Dispatch<SetStateAction<FormDataType>>) => {
  const { data, isSuccess } = useGetWebApplicationSettingsQuery();

  useEffect(() => {
    if (isSuccess) {
      setFormData({
        ...data,
        placeDetail: data.imageQualitySettings.placeDetail,
        placeList: data.imageQualitySettings.placeList,
        productCategoryAll: data.imageQualitySettings.productCategoryAll,
        productDetail: data.imageQualitySettings.productDetail,
        productList: data.imageQualitySettings.productList,
        storyDetail: data.imageQualitySettings.storyDetail,
        storyDetailHeader: data.imageQualitySettings.storyDetailHeader,
        storyList: data.imageQualitySettings.storyList,
      });
    }
  }, [isSuccess]);

  return { data };
};
